import React from "react";
import { Form } from "react-bootstrap";
import NumberInputWithControls from "../../../../Common/number-input-with-controls/number-input-with-controls.component";
import styles from "./renewal-notifications.component.module.scss";
import { NotificationItem } from "../mock-data";

interface RenewalNotificationsHandlers {
  handleValueChange: (id: number, value: string | number) => void;
  handleIncrement: (id: number) => void;
  handleDecrement: (id: number) => void;
  handleCheckboxChange: (id: number) => void;
}

interface RenewalNotificationsComponentProps {
  renewalNotifications: NotificationItem[];
  handleRenewalNotifications: RenewalNotificationsHandlers;
}

const RenewalNotificationsComponent = ({ 
  renewalNotifications,
  handleRenewalNotifications
}: RenewalNotificationsComponentProps) => {

  return (
    <div className={styles.container}>
      {renewalNotifications.map((notification) => (
        <div
          key={notification.id}
          className={styles.notificationItem}
        >
          <div className={styles.labelContainer}>
            <div className={styles.checkboxGroup}>
              <Form.Group className="fixed-checkbox blue-checkbox fix-checkbox pointer-checkbox">
                <Form.Check
                  type="checkbox"
                  id={`checkbox-${notification.id}`}
                  checked={notification.checked}
                  onChange={() => handleRenewalNotifications.handleCheckboxChange(notification.id)}
                  label=""
                />
              </Form.Group>
            </div>

            <label
              htmlFor={`notification-${notification.id}`}
              className={styles.label}
            >
              {notification.label}
            </label>
          </div>

            <NumberInputWithControls
              id={`notification-${notification.id}`}
              value={notification.value}
              onChange={(value: string | number) => handleRenewalNotifications.handleValueChange(notification.id, value)}
              onIncrement={() => handleRenewalNotifications.handleIncrement(notification.id)}
              onDecrement={() => handleRenewalNotifications.handleDecrement(notification.id)}
              outputText="days"
              ariaLabel={`${notification.label} days`}
              min="0"
            />
        </div>
      ))}
    </div>
  );
};

export default RenewalNotificationsComponent;
